import 'common/log';
import 'config/axios';
import 'config/bluebird';
import 'config/moment';
import _ from 'lodash';
import Promise from 'bluebird';
import React from 'react';
import ReactDOM from 'react-dom';
import {AppModuleType} from 'common/AppModule'
import {AppBoundary} from 'component/AppBoundary';
import {applyMiddleware, compose, createStore} from 'redux';
import {combineEpics, createEpicMiddleware} from 'redux-observable';
import {appInitAction} from "util/ReduxUtil";
import {commonEpics, commonProperties, commonReducers} from 'common/CommonBase';
import {loadUpgradedStateFromLocalStorage} from 'util/redux/ReduxStateUtil';
import combineReducers from 'combine-reducers-global-state/lib';
import {appReady} from 'common/appReady';
import 'common/globals'
import {isDebugEnabled, isTraceEnabled} from 'common/log';
import {ignoreElements, tap} from 'rxjs/operators';

window.sis = {
	...window.sis,
	_,
	debug() {
		_.assign(window, window.sis);
	},
};

//deferred usage because imports are using appInitialized and entryPoint initializes the app.
let _resolveAppInit: Function;
export const appInitialized = new Promise(res => _resolveAppInit = res);

export function initReactApp(AppModule: AppModuleType) {
	const {App, reducers, epics, properties, actions} = AppModule;
	const composeEnhancers = window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

	const epicMiddleware = createEpicMiddleware();

	const storePromise = appReady
		.then(() => loadUpgradedStateFromLocalStorage())
		.then(lastState => {
			const store = createStore(
				combineReducers({...reducers, ...commonReducers}),
				lastState,
				composeEnhancers(
					applyMiddleware(epicMiddleware),
				),
			);

			if (isTraceEnabled()) {
				epicMiddleware.run(action$ => action$.pipe(
					tap(action => console.log('redux action', action.type, action)),
					ignoreElements(),
				))
			}

			epicMiddleware.run(combineEpics(...epics));
			epicMiddleware.run(combineEpics(...commonEpics));

			if (isDebugEnabled()) window.sis = {...window.sis, store}

			store.dispatch(appInitAction({properties: [...properties, ...commonProperties]}));

			actions.forEach(action => store.dispatch(action));

			return store;
		});


	_resolveAppInit(
		storePromise.then((store) => {
			ReactDOM.render(
				<AppBoundary store={store}>
					<App/>
				</AppBoundary>, document.getElementById('ReactRoot'));
			return {store, epicMiddleware};
		}).catch((...err) => console.error(...err)),
	);
}